import logo2 from '../images/admin/google_logo.jpg'
import logo3 from '../images/admin/Oracle_Logo.png'
import {camsol_logo1,velte_logo} from '../images'
export const companyData = [
  {
    companyName:"Google",
    logo:logo2,
    about:"Google LLC is an American multinational technology company that specializes in Internet-related services and products, which include a search engine, online advertising technologies, cloud computing, software, and hardware. It has been referred to as the 'most powerful company in the world' and one of the world's most valuable brands due to its market dominance, data collection, and technological advantages in the area of artificial intelligence. It is considered one of the Big Five American information technology companies, alongside Amazon, Apple, Meta and Microsoft.",
    aboutSource:[
      {
        name:"wikipedia",
        link:"https://en.wikipedia.org/wiki/Google",

      }
    ],

    MainLocation:"facke location",
    OtherLocations:[
      {
        name:"buea",
        link:"kjklj"

      },
      {
        name:'buea2',
        link:'lkjlj'
      }
    ],
    LocationSources:[
      {
        link:"fake.com",
        name:'fake'
    }
  ],
  JobPost:[
    {
      name:"JavaScript Developer-220005B3",
      location:"Hungary",
      link:"https://oracle.taleo.net/careersection/2/jobdetail.ftl?job=220005B3&tz=GMT-05%3A00&tzname=America%2FChicago",
      analysisStatus:"Unclear",
      reasonForAnalysis:"Oracle Branch not located in Hungary. closest name by google search engin and adress is Oracle Hungary Kft with location unNamed",
      analysisSource:[
        {name:"Google maps",
        link:"https://www.google.com/maps/place/Balatoni+%C3%BAt+2-a,+1112/@47.4314382,19.0044028,19.49z/data=!4m6!3m5!1s0x4741e769fcd27d11:0x30b6975883893457!4b1!8m2!3d47.431454!4d19.0047786"},
      ],
    },
  ],

  JobPostSources:[
    {
      name:"Oracle",
      link:"https://oracle.taleo.net/careersection/2/jobdetail.ftl?job=220005B3&tz=GMT-05%3A00&tzname=America%2FChicago"
  }
],

    Employee:[
      {
        year:"2020",
        numberOfEmployee:"135,301"
    },
    {
      year:"2021",
      numberOfEmployee:"156,500"
  },

],
    EmployeeType:'Full-time Employee',
    EmployeeSource:[
      {
        name:"statista.com",
        link:"https://www.statista.com/statistics/273744/number-of-full-time-google-employees/",

      }
    ],
    Revenue:[
      {
        year:'2020',
        amount:'181.69'
      },
      {
        year:'2021',
        amount:'256.74'

      }
    ],
    RevenueType:'Revenue in Million U.S dollars',
    RevenueSource:[
      {name:"statista.com",
      link:"https://www.statista.com/statistics/266206/googles-annual-global-revenue/",
      }
    ],
    Departments:[
      {
        DepartmentName:'Engineering & Technology',
        DepartmentDesc:''
      },

      {
        DepartmentName:'Sales, Service & Support',
        DepartmentDesc:''
      },
      {
        DepartmentName:'Marketing & Communications',
        DepartmentDesc:''
      },
      {
        DepartmentName:'Design',
        DepartmentDesc:''
      },
      {
        DepartmentName:'Business Strategy',
        DepartmentDesc:''
      },
      {
        DepartmentName:'Finance',
        DepartmentDesc:''
      },
      {
        DepartmentName:'Legal',
        DepartmentDesc:''
      },
      {
        DepartmentName:'People',
        DepartmentDesc:''
      },
      {
        DepartmentName:'Facilities',
        DepartmentDesc:''
      },
    ],
    DepartmentSource:[
      {
        name:"careers.google.com",
        link:"https://careers.google.com/teams/",
      }
    ]



  },

  {
    companyName:"Oracle",
    logo:logo3,
    about:"Oracle Corporation is an American multinational computer technology corporation headquartered in Austin, Texas. In 2020, Oracle was the second-largest software company in the world by revenue and market capitalization. The company sells database software and technology (particularly its own brands), cloud engineered systems, and enterprise software products, such as enterprise resource planning (ERP) software, human capital management (HCM) software, customer relationship management (CRM) software (also known as customer experience), enterprise performance management (EPM) software, and supply chain management (SCM) software.  The company is best known for its Oracle database software, a relational database management system, and for computer systems and software, such as Solaris and Java, acquired in its purchase of Sun Microsystems in 2010.",
    aboutSource:[
      {
        name:"wikipedia",
        link:"https://en.wikipedia.org/wiki/Oracle_Corporation",

      },
      {
        name:"britannica",
        link:"https://www.britannica.com/topic/Oracle-Corporation",

      },
    ],
    MainLocation:"Austin, Texas",
    TotalNumberOfBranches:"47",
    OtherLocations:[
      {
        name:"Oracle Building 15",
        link:"https://foursquare.com/v/oracle-building-15/4c26e81d905a0f47e0326460"

      },
      {
        name:'Oracle Dubai Internet City',
        link:'https://foursquare.com/v/oracle-dubai-internet-city/4ca0690b7c096dcb5788e6d1'
      },
      {
        name:'Oracle Systems',
        link:'https://foursquare.com/v/oracle-systems/4ea531c1f7909c68df3f1a24'
      }
    ],
    LocationSources:[
      {
        name:'foursquare',
        link:"https://foursquare.com/sdiedericks/list/oracle-offices-around-the-world"
      }
    ],

    JobPost:[
      {
        name:"JavaScript Developer-220005B3",
        location:"Hungary",
        link:"https://oracle.taleo.net/careersection/2/jobdetail.ftl?job=220005B3&tz=GMT-05%3A00&tzname=America%2FChicago",
        analysis:{
          status:"unclear",
          jobLocation:"Hungary",
          currentOfficeLocation:"Hungary is not one",
          details1:"Employee number keeps droping form 2019 to 2021 a total number of drop of 4,000 employees",
          details2:"Oracle annual revenue for 2021 was $40.479B, a 3.61% increase from 2020.",
          details3:"Oracle annual revenue for 2020 was $39.068B, a 1.11% decline from 2019",
          details4:"Oracle annual revenue for 2019 was $39.506B, a 0.31% increase from 2018"
        },
        reasonForAnalysis:"Oracle Branch not located in Hungary. closest name by google search engin and adress is Oracle Hungary Kft with location unNamed",
        analysisSource:[
          {name:"Google maps",
          link:"https://www.google.com/maps/place/Balatoni+%C3%BAt+2-a,+1112/@47.4314382,19.0044028,19.49z/data=!4m6!3m5!1s0x4741e769fcd27d11:0x30b6975883893457!4b1!8m2!3d47.431454!4d19.0047786"},
        ],
      },
    ],
    JobPostSources:[
      {
        name:"Oracle",
        link:"https://oracle.taleo.net/careersection/2/jobdetail.ftl?job=220005B3&tz=GMT-05%3A00&tzname=America%2FChicago"
    }
  ],
    Employee:[
      {
        year:"2019",
        numberOfEmployee:"136"
    },
      {
        year:"2020",
        numberOfEmployee:"135"
    },
    {
      year:"2021",
      numberOfEmployee:"132"
  },

],
    EmployeeType:'Full-time Employee in thousands',
    EmployeeSource:[
      {
        name:"statista.com",
        link:"https://www.statista.com/statistics/236999/number-of-employees-at-oracle-worldwide/",

      }
    ],
    Revenue:[
      {
        year:'2019',
        amount:'39.506'
      },
      {
        year:'2020',
        amount:'39.068'
      },
      {
        year:'2021',
        amount:'40.479'

      }
    ],
    RevenueType:'Revenue in Billions U.S dollars',
    RevenueSource:[
      {name:"macrotrends.com",
      link:"https://www.macrotrends.net/stocks/charts/ORCL/oracle/revenue",
      }
    ],
    Departments:[
      {
        DepartmentName:'Product Development',
        DepartmentDesc:{
          details1:""
        }
      },

      {
        DepartmentName:'Sales',
        DepartmentDesc:{
          details1:""
        }
      },
      {
        DepartmentName:'Consulting',
        DepartmentDesc:{
          details1:""
        }
      },
      {
        DepartmentName:'Pre Sales',
        DepartmentDesc:{
          details1:""
        }
      },
      {
        DepartmentName:'Support',
        DepartmentDesc:{
          title:"Support Department",
          role:"To help ....",
          details1:""
        }
      },

    ],
    DepartmentSource:[
      {
        name:"oracle",
        link:"https://eeho.fa.us2.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX_1/requisitions?lastSelectedFacet=CATEGORIES&location=United+States&locationId=300000000149325&selectedCategoriesFacet=300000001917358%3B300000001917354",
      }
    ]



  },
  {
    companyName:"Hippo Education",
    logo:"https://media.glassdoor.com/sqll/965722/hippo-education-squarelogo-1566514260455.png",
    about:"Hippo Education provides medical educational programs online. Aaron Bright founded it in 2011.Hippo Education is a new-school web based medical education company specializing in exceptional content and entertaining delivery. We are backed by a deep bench of talent and experience in the medical education arena.",
    aboutSource:[
      {
        name:"Crunchbase",
        link:"https://www.crunchbase.com/organization/hippo-education",

      },
      {
        name:"linkedin",
        link:"https://www.linkedin.com/company/hippo-education-inc-/about/",

      },
    ],
    MainLocation:"California | Los Angeles, CA",
    TotalNumberOfBranches:"1",
    OtherLocations:[
      {
        name:"Just one at Los Angeles, CA",
        link:"http://www.hippoeducation.com/"

      },
    ],
    LocationSources:[
      {
        name:'foursquare',
        link:"https://foursquare.com/sdiedericks/list/oracle-offices-around-the-world"
      }
    ],

    JobPost:[
      {
        name:"Frontend React Developer",
        location:"Los Angeles",
        link:"https://www.careers.hippoed.com/frontend-react-developer",
        analysis:{
          status:"clear",
          jobLocation:"Los Angeles or Remote",
          currentOfficeLocation:"Los Angeles",
          details1:"2+ years experience with React / React Native =>4+ years frontend/ui mobile-first development =>Rich web animation skills (Html5, Css3, Svg, etc)=> Experience using CSS preprocessors (sass / less) => Familiarity with Typescript =>Experience using REST API, GraphQL, and/or Firestore data sources =>Proficient with GitHub =>A portfolio of projects utilizing the above skills =>Excellent communication skills=>A great sense of humor, optimism, and collaboration",
          details2:"Full time with remote / telecommute option",
          details3:"Competitive salary, vacation, 401(k) match, health, vision, and dental insurance",
          details4:"https://careered.referrals.selectminds.com/jobs/frontend-react-developer-hippo-education-8711 and provide links to relevant examples of recent work (your GitHub or equivalent profile would be a great way to start)."
        },
        reasonForAnalysis:"It is a fit, all requires are checked and with evidence, plus it is medical giving the ability to extend studies the human biology plus the pay is good",
        analysisSource:[
          {name:"Hippo Education",
          link:"https://www.careers.hippoed.com/frontend-react-developer"},
        ],
      },
    ],
    JobPostSources:[
      {
        name:"Hippo Education",
        link:"https://www.careers.hippoed.com/frontend-react-developer"
    }
  ],

  Employee:[
    {
      year:"2019",
      numberOfEmployee:"31"
  },

  {
    year:"2021",
    numberOfEmployee:"61"
},

],
EmployeeType:'Full-time Employee',
EmployeeSource:[
  {
    name:"linkedin.com",
    link:"https://www.linkedin.com/company/hippo-education-inc-/people/",

  },
  {
    name:"federal pay",
    link:"https://www.federalpay.org/paycheck-protection-program/hippo-education-llc-woodland-hills-ca",
  }
],
Revenue:[
  {
    year:'2019',
    amount:'6'
  },
  {
    year:'2020',
    amount:'unknown'
  },
  {
    year:'2021',
    amount:'Unknown'

  }
],
RevenueType:'Revenue in Millions U.S dollars',
RevenueSource:[
  {name:"zoominfo",
  link:"https://www.zoominfo.com/c/hippo-education-llc/357830893",
  }
],
Departments:[
  {
    DepartmentName:'Unknown',
    DepartmentDesc:{
      details1:"Department number:Unknown, Name:Unknown, "
    }
  },
],
DepartmentSource:[
  {
    name:"",
    link:"",
  }
]
  }
  ,
  {
    companyName:"Red Acre",
    logo:"https://redacreltd.com/wp-content/uploads/2020/01/redacre-logo.svg",
    about:"From fintech to blockchain technology, Red Acre has worked across multiple cutting-edge industries to offer world-class business solutions and alternatives to make your life easier. We aim to ease the pressure of running a business and build sustainable platforms that support and enable your business to leap to the next level.",
    about2:"Leading the way with innovative back office services. We offer bespoke solutions to all your business needs - covering compliance, payments, general support and bespoke office systems.",
    about3:"Red Acre provides back office solutions and services to improve business processes. It offers online customer support assistance and give choices for compliance and payment providers. Red Acre is based in Valletta, Malta.",
    about4:"Founded 2019 with 126 total number of employees or 160 employees by apollo and Company revenue:$10 - 49 M by infotelligent",
    aboutPopUp:[
      {
        name:"fintech",
        details1:"Fintech, or financial technology, is the term used to describe any technology that delivers financial services through software, such as online banking, mobile payment apps or even cryptocurrency.",
        details2:"Fintech is a broad category that encompasses many different technologies, but the primary objectives are to change the way consumers and businesses access their finances and compete with traditional financial services.",
        popUpSources:[
          {
            name:"fintech",
            link:"https://www.uschamber.com/co/run/business-financing/what-is-fintech",
          },
        ],


      },
      {
        name:"Blockchain",
        details1:"Blockchain defined: Blockchain is a shared, immutable ledger that facilitates the process of recording transactions and tracking assets in a business network.",
        details2:"An asset can be tangible (a house, car, cash, land) or intangible (intellectual property, patents, copyrights, branding).",
        details3:"Virtually anything of value can be tracked and traded on a blockchain network, reducing risk and cutting costs for all involved.",
        popUpSources:[
          {
            name:"Blockchain",
            link:"https://www.uschamber.com/co/run/business-financing/what-is-fintech",
          },
        ],


      },
    ],
    aboutSource:[
      {
        name:"Red Acre",
        link:"https://redacreltd.com/",

      },
      {
        name:"Red Acre Ltd by infotelligent",
        link:"https://infotelligent.com/company/red-acre-ltd/42208080",

      },
      {
        name:"Red Acre Ltd Information",
        link:"https://rocketreach.co/red-acre-ltd-profile_b450ebd8fc7c0b7c",

      },
      {
        name:"Red Acre Ltd Details",
        link:"https://www.apollo.io/companies/Red-Acre-Ltd/5da5312ae409180001e2e664?chart=count",

      },
      {
        name:"linkedin",
        link:"https://www.linkedin.com/company/red-acre-ltd/?originalSubdomain=ie",

      },
      {
        name:"facebook",
        link:"https://www.facebook.com/redacreltd/",

      },
    ],
    MainLocation:"Valletta, Malta. Time zone in Malta (GMT+2)",
    TotalNumberOfBranches:"!!!!!!!Unknown!!!!!!!",
    OtherLocations:[
      {
        name:"!!!!!!!Unknown!!!!!!!",
        link:"https://redacreltd.com/"

      },
    ],
    LocationSources:[
      {
        name:"Red Acre",
        link:"https://redacreltd.com/",
      }
    ],

    JobPost:[
      {
        name:"Full-Stack Developer",
        location:"Dublin, Limassol and Tallin, with headquarters in Malta",
        link:"https://careers.redacreltd.com/jobs/8r1ch-_it9ZI/full-stack-developer",
        analysis:{
          status:"Unclear",
          jobLocation:"Malta",
          currentOfficeLocation:"Valletta, Malta",
          details1:"Type: Platform ?????????? what does this mean?????????",
          details2:"Technology : JavaScript, NodeJS, MongoDB",
          details3:"The Red Acre Goal:  Here at Red Acre, we are expanding our team! We are looking for Full-stack Developers with experience in JavaScript, to help us deliver great products and services to our users. You will join one of our agile development teams to help improve the capabilities of our products by making sure each feature works at its best. You’ll be working across the stack of our API-centric platform to solve complex problems. As a full-stack developer, you focus on solid engineering practices. We are a global company based in Dublin, Limassol and Tallin, with headquarters in Malta, empowering businesses through Software as a Service solution.",
          details4:"What you’ll do: Solve challenges with creativity and initiative && Design, develop and deploy both backend and frontend services that support high traffic, focusing on low latency, scalability, and high availability &&  Collaborate and work closely with other developers, becoming a valued member of a self-managing and self-organising, cross-functional team && Continuously improve the products and architecture by participating in code reviews and innovating on the services && Write clean, readable, and maintainable code with unit and integration tests, making continuous improvements to the codebase, creating proper documentation, including API documentation && Participate and support the Agile methods and frameworks by taking part in quarterly planning events, daily stand-ups, planning sessions, code reviews and other discussions and events && Follow and take part in all agile practices, work as a team and ensure timely delivery.",
          details5:"Our current tech stack: ==> Front-End: JavaScript, Typescript, ReactJS, Html5, SCSS",
          details6:"Our current tech stack: ==> Back-End: JavaScript, NodeJS, Express, MongoDB, PostgreSQL, REST API, Python, Golang",
          details7:"Other: Gitlab, Gitlab CI, Jenkins, Docker, AWS, VS Code",
          details8:"About you: You architect, design, develop and maintain JavaScript code with a handful of other languages && You are interested in keeping up with current standard methodologies && You know and care about engineering practices like CI/CD and automated testing && You have working knowledge in Agile methodologies && You have excellent analytical and problem-solving skills and can communicate your ideas to both technical and non-technical audiences && You enjoy sharing knowledge with others && You are motivated and love working in fast-paced environments",
          details9:"Question 1 !!!!!!!: under your careerpage in the full-stack developer job post, you mension the``` type: platform```. can you please elaburate",
          details10:"Question 2 !!!!!!!: In the ```why us``` page, This was one of the first reason i applied for the position, ==>under the topic ```Be part of an ever-expanding team of the brightest talent.```, you mensioned ```!!! We want to be not just a workplace for our employees - we want to be a place to develop and grow.!!!```: . can you please elaburate",
          imageName:"company Growth chart",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653144197/msbGeanologyProfilePics/red_arce_l7gykw.png",
          popUpSources:[
            {
              name:"company Growth chart",
              link:"https://rocketreach.co/red-acre-ltd-management_b450ebd8fc7c0b7c",
            },
            {
              name:"careers at red acre",
              link:"https://careers.redacreltd.com/jobs",
            },
            {
              name:"full-stack developer",
              link:"https://careers.redacreltd.com/jobs/8r1ch-_it9ZI/full-stack-developer",
            },
            {
              name:"Ever expanding team",
              link:"https://redacreltd.com/why-us/"
            }
          ],
        },
        reasonForAnalysis:"It is a fit, all requires are checked and with evidence, plus it is medical giving the ability to extend studies the human biology plus the pay is good",
        analysisSource:[
          {name:"Hippo Education",
          link:"https://www.careers.hippoed.com/frontend-react-developer"},
        ],
      },
    ],
    JobPostSources:[
      {
        name:"Hippo Education",
        link:"https://www.careers.hippoed.com/frontend-react-developer"
    }
  ],

  Employee:[
    {
    year:"2022",
    numberOfEmployee:"201-500"
},

],
  EmployeeType:'Full-time Employee',
  EmployeeSource:[
  {
    name:"linkedin.com",
    link:"https://www.linkedin.com/company/hippo-education-inc-/people/",

  },
  {
    name:"federal pay",
    link:"https://www.federalpay.org/paycheck-protection-program/hippo-education-llc-woodland-hills-ca",
  }
],
  Revenue:[
  {
    year:'2019',
    amount:'$10 - 49 M'
  },

],
  RevenueType:'Revenue in Millions U.S dollars',
  RevenueSource:[
  {
    name:"Red Acre Ltd by infotelligent",
    link:"https://infotelligent.com/company/red-acre-ltd/42208080",

  },
],
  Departments:[
  {
    DepartmentName:'Unknown',
    DepartmentDesc:{
      details1:"Department number:Unknown, Name:Unknown, "
    }
  },
],
  DepartmentSource:[
  {
    name:"",
    link:"",
  }
],
  ApplicationStatus:"In Active",
  ApplicationStage:[
    {
      stageName:"Stage1-Applying for job",
      stagePercent:100,
      about:"This is the application phase to the company for the position of full stack developer",
      about2:"!!!!!!!!!!!!!!!!!Cover letter unavialable.!!!!!!!!!!!!!!!!!",
      aboutPopUp:[
        {
          name:"Resume",
          imageName:"Resume Image",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653477784/msbGeanologyProfilePics/Resume1024_1_ws31nm.jpg",
          popUpSources:[
            {
            name:"resume ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        }
      ]
    },
    {
      stageName:"Stage2-First human response form company",
      stagePercent:100,
      about:"Monitoring first contact form the company(Not auto reply)",
      about2:"1.) first feedback was form Red Arce, Not sure if it was Auto reply or not",
      about3:"2.) second was from Recruter name: Serena Lacerenza",
      aboutPopUp:[
        {
          name:"first feedback",
          imageName:"first feedback mail",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653479757/msbGeanologyProfilePics/Red%20Arce/R1_abgozi.png",
          popUpSources:[
            {
            name:"mails ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:"second feedback mail from serena",
          imageName:"second feedback mail from serena",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653479913/msbGeanologyProfilePics/Red%20Arce/R2_oin92w.png",
          popUpSources:[
            {
            name:"mails ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:"My reply to second feedback mail from serena",
          imageName:"My reply to second feedback mail from serena",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653480143/msbGeanologyProfilePics/Red%20Arce/R3_gnk4ot.png",
          popUpSources:[
            {
            name:"mails ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        }
      ]
    },
    {
      stageName:"Stage3-Technical assesment",
      stagePercent:100,
      about:"Technical Assessment",
      about2:"Invitation and preparation for Technical Assesment",
      about3:"Technical Assesment",
      aboutPopUp:[
        {
          name:"Invitation and Preparation 1",
          details1:"This was a creation of a private github account inviting me to be a contributer.",
          details2:"Here i will have Push privilages such that what ever the Assesment is i will push here for their evaluation",
          imageName:"Invitation and Preparation 1",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653481052/msbGeanologyProfilePics/Red%20Arce/R4_mqzuyt.png",
          popUpSources:[
            {
            name:"email ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:"Invitation and Preparation 2",
          details1:"Strict instructions on what to build.the document is in the source",
          details2:"You are required to develop a Widget for one of our clients. This widget will be used to display several currency exchanges rates and it will allow the user to exchange USD (Note#1) for Crypto(Note#2).The application consists of a React front-end client and a Node back-end service(Express.js).",
          details3:"Criteria: The application must meet all the following criteria",
          details4:"1.) Front-end must have a toolbar with two dropdowns and two input fiels where you can pick the currency that you want to exchange from and the Crypto that you want to exchange to.",
          details5:"2.) Front-end must have a table component to display historical data(Note#3)",
          details6:"3.) Back-end service must consume the rates from the API(Note#4) every few minutes(configurable Number),store the data in the Database (Note#5) and stream the data to the front-end using WebSockets.",
          details7:"4.) Latest Node and React versions must be used.",
          details8:"5.) You need to upload the repository to GitHub and share the link.",
          details9:"6.) Yoy need to create a short video to demo the application in a working state",
          details10:"7.) Assesment will be rejected if no readme file is provided with instruction on how to run the project.",
          details11:"Bonus points ==> Dockerize the application, ==>Documentation of the code with comments. ==>Unit-test, ==>Add a Date Picker Filter (any Date Picker can be used) on the table to filter data by time, ==> Add sorting for all columns on the table. ==> Mobile view must be exact as the design provided.",
          details12:"Notes ==> USD is mandatory.EUR, GBP and other fiat currencies are optional. ==> BTC and ETH are mandatory.Other Cryto are optional ==>Table fields are 'Date & Time', 'Currency form','Amount 1', 'Currency to','Amount 2','Type'. ===> There are two types of data, 'Live Price' and 'Exchanged', ==>'Live Price' indicates the rate coming form the API and it is the currency conversion of any currency to USD. For example the live price of 1BTC is 44000 USD. ===> 'Exchange' indicates the transaction happened when the user clicked 'SAVE' button . for exmple the user exchanged 44000 USD to get 1 BTC. ==> Any API can be used of even a mock server that returns fake data. ==> you can use either Mongo or MySQL.",
          details13:"Good luck!",
          imageName:"Invitation and Preparation 2",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653483743/msbGeanologyProfilePics/Red%20Arce/R5_opb7tv.png",
          popUpSources:[
            {
            name:"email ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:"My Reply about the Assesment",
          details1:"There are two reason why I reply this mail.",
          details2:"1.) let the recruiter be familia with you (formal way of socializing)",
          details3:"2.) Make the recruiter know you have started your assesment",

          imageName:"My Reply about the Assesment",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653484427/msbGeanologyProfilePics/Red%20Arce/R6_rongwy.png",
          popUpSources:[
            {
            name:"email ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:"Her reply to My quesion on Assesment",
          details1:"From her mail, you can tell if she is getting familia and comfortable with you or not",
          details2:"1.) In this case, she is now on first Name basis, and Hi is used instead of Dear.",

          imageName:"Her reply to My quesion on Assesment",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653484853/msbGeanologyProfilePics/Red%20Arce/R7_esn7z5.png",
          popUpSources:[
            {
            name:"email ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },

      ]
    },
    {
      stageName:"Stage4-Delevary of Assesment",
      stagePercent:100,
      about:"Delevary of Assesment",
      about2:"I deleverded the first part of the assesment befor time and the second part on the due date",
      aboutPopUp:[
        {
          name:"first delivery of Assesment",
          details1:"Deliver on time and just the very basic of what is required of you to do",
          details2:"Link delivery message to your previous conversation",
          imageName:"first delivery of Assesment",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653485123/msbGeanologyProfilePics/Red%20Arce/R8_qi8hag.png",
          popUpSources:[
            {
            name:"resume ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },

        {
          name:"Her reply to the first delivery",
          details1:"This is the sign the conversation is going",
          imageName:"her reply to the first deliver",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653485406/msbGeanologyProfilePics/Red%20Arce/R9_xxkx1r.png",
          popUpSources:[
            {
            name:"resume ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:"second/full delivery of Assesment",
          details1:"Deliver on time and either all or at most what you have done about the application just before due date",
          details2:"Link delivery message to your previous conversation",
          imageName:"second/full delivery of Assesment",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653485590/msbGeanologyProfilePics/Red%20Arce/R10_mtzikq.png",
          popUpSources:[
            {
            name:"resume ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:"Follow up mail",
          details1:"If the recruiter stays for long without saying anything after the full delivery, send a follow up mail",
          details2:"wait untill she replies your follow up mail",
          imageName:"Follow up mail",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653485767/msbGeanologyProfilePics/Red%20Arce/R11_k4gyep.png",
          popUpSources:[
            {
            name:"resume ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
      ]
    },
    {
      stageName:"Stage5-Awaiting a reply from assesment or follow up mail",
      stagePercent:100,
      about:"This could either be a mail with the following,",
      about2:"case 1==>This could be a mail telling you to be patient for the results of your assesment",
      about3:"case 2==> This could be a mail telling you the result of your assesment and you did not make it",
      about4:"case 3==> This could be mail on setting interview time",
      about5:"case 4==> Congratulation, you made it to interview",

      aboutPopUp:[
        {
          name:"case 1",

          imageName:"case 1",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653486689/msbGeanologyProfilePics/Red%20Arce/R12_sfsgj6.png",
          popUpSources:[
            {
            name:"resume ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:"replying to case 1",
          details1:"be apriciative of the opotunity, many don't make it this far",
          imageName:"replying to case 1",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653486845/msbGeanologyProfilePics/Red%20Arce/R13_sx5i7a.png",
          popUpSources:[
            {
            name:"resume ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:"case 3",
          imageName:"case 3 setting up interview time",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653487830/msbGeanologyProfilePics/Red%20Arce/R14_xdrvop.png",
          popUpSources:[
            {
            name:"mail ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:"reply to case 3",
          imageName:"reply to case 3 setting up interview time",
          details1:"choose a time in which the recruiter will be most okay with.",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653487962/msbGeanologyProfilePics/Red%20Arce/R15_x2zwdf.png",
          popUpSources:[
            {
            name:"mail ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:" case 4",
          imageName:"case 4 ",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653488092/msbGeanologyProfilePics/Red%20Arce/R16_frar7u.png",
          popUpSources:[
            {
            name:"mail ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:" reply to case 4",
          imageName:"reply to case 4 ",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653488251/msbGeanologyProfilePics/Red%20Arce/R17_kk5je8.png",
          popUpSources:[
            {
            name:"mail ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:" her reply to my reply to case 4",
          imageName:"her reply to my reply to case 4 ",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653488381/msbGeanologyProfilePics/Red%20Arce/R18_mgfxeo.png",
          popUpSources:[
            {
            name:"mail ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
      ]
    },
    {
      stageName:"Stage6-The Interview",
      stagePercent:100,
      about:"Preparation for the Interview",
      about2:"case 1==> Most common interview quesions and how to answer them",
      about3:"case 2==> reserch about those you are sopose to have interview with",
      about4:"case 3==> prepare the place and time and internet you need for the interview",
      about5:"case 4==> Have the interview",
      about6:"case 5==> Follow up interview quesions",

      aboutPopUp:[
        {
          name:"case 1",
          details1:"!!!!!!!!!!! No fomal preparation done!!!!!!!!!!!!",
          // imageName:"case 1",
          // imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653486689/msbGeanologyProfilePics/Red%20Arce/R12_sfsgj6.png",
          popUpSources:[
            {
            name:"resume ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:"case 2",
          details1:"Serena research in in the company structural detail but not much about the techlead",
          // imageName:"replying to case 1",
          // imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653486845/msbGeanologyProfilePics/Red%20Arce/R13_sx5i7a.png",
          popUpSources:[
            {
            name:"resume ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:"case 3",
          details1:"Nokeli consulting lcc office, internet was put in both MTN and Orange networks",
          // imageName:"case 3 setting up interview time",
          // imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653487830/msbGeanologyProfilePics/Red%20Arce/R14_xdrvop.png",
          popUpSources:[
            {
            name:"mail ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:"case 4",
          // imageName:"case 4",
          details1:"!!!!!!!!!forgot to take a screen shot of the interview going on.!!!!!!",
          // imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653487962/msbGeanologyProfilePics/Red%20Arce/R15_x2zwdf.png",
          popUpSources:[
            {
            name:"mail ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:" case 5",
          imageName:"case 5 interview Quesion follow up",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653489494/msbGeanologyProfilePics/Red%20Arce/R19_ymv6c4.png",
          popUpSources:[
            {
            name:"mail ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:" Her reply to case 5",
          imageName:"Her reply to case 5 ",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653489999/msbGeanologyProfilePics/Red%20Arce/R20_a74xpq.png",
          popUpSources:[
            {
            name:"mail ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:" About my salary and job conditions",
          imageName:"About my salary and job conditions",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653490383/msbGeanologyProfilePics/Red%20Arce/R21_rqkc71.png",
          popUpSources:[
            {
            name:"mail ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
      ]
    },
    {
      stageName:"Stage7-Awaiting Interview Result",
      stagePercent:100,
      about:"Awaiting result of the Interview",
      about2:"case 1 ==> Congratulation, you have been selected for the next phase",
      about3:"case 2 ==> Unfortunately ......",
      aboutPopUp:[
        {
          name:"case 2",
          imageName:"Unfortunately ...",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653491167/msbGeanologyProfilePics/Red%20Arce/R22_zddlyh.png",
          popUpSources:[
            {
            name:"resume ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:"My reply to case 2",
          imageName:"reply to case 2",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653491309/msbGeanologyProfilePics/Red%20Arce/R23_cfe10v.png",
          popUpSources:[
            {
            name:"resume ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        },
        {
          name:"Her reply to My reply to case 2",
          imageName:"Her reply to My reply to case 2",
          imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653491470/msbGeanologyProfilePics/Red%20Arce/R24_lt45cc.png",
          popUpSources:[
            {
            name:"resume ",
            link:"https://github.com/mrsuber/my-resume-cv"
          }
          ]
        }


      ]
    },
  ]

},
{
  companyName:"proxify",
  logo:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAA0lBMVEX///9odezM0dcAPBxWwohNwIOu38RFvn7y+vZebOtlc+zU1/n5+v5jceyAjO+QmfEAKAAALwAAJwAANRAAKwAAMgj19vfW2t/o9u4AOBbq7+wAMQDe4eXS1tsAJAB/j4Tv8fOtu7O8yMHa4NxQbluPo5fJ0s1bxIw9YUvc8eWY2LTJ6thzy5slUDbCx/eor/TLz/ifsKY1VkA7vHlfe2pzjH0SRCeIm4+D0aZbd2a75c1qyZZHalW0wLmg27prgHKN1a3o6fx2ge6epfK3vfbw8f1EQ5JKAAAHGklEQVR4nO2be1vaShCHsakWaT1NyEXCRcPNSpVj8Yh4Q61tv/9XOiBeEpKQ7M5vbPCZ929dfZ/ZnZnd7JZKgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAI60W922mP+v1Ru9Ot5/n52hYEbq0nuqPLU7/qONYcp+qe9kZdL+N3jj5tAviv/AZ6nTOjatm+EcK3LdPvTVdKHm1+BPCJ3bA+ts2o3aul07jrpv/mYC0M62PHTdR7wjXPUh3XwdAbm+4KvUfsvbuUvFMrvmHbb2T5PcaxMUr89XLRDb1eddX8DGMeJoYRIcho2D3PnKChqWp3Eoa4LrThKHcAH/H3+vExLhDTlMuwb6r4zamOY4N8L7DhZE9V0DCcu+VRtoprqCM4U1yOIqQgshiOlKfoAnMSHQdSEDkMD6p6goax146O9K2YhnVfKYtGoxht4RDJlMHw0NYWNOxhZChEqsEb9h19QcOwItlm8KmAhvVcrWg6TmSeFjGGlwq9WhL2aXg0wEJEGx5oVcIwZjifXhXPsEdIMwv8cLKp0Rci2FC/FIaCGN5m0LcXYMMbcghnQTwMDUivF1jDOqlSPBNOp/TGDWs4shCG7n5oSHI2xRqe6vdrIfzz0JDkQ1OoYV1zT7GMeRAalNp9Qw2nkGVoGI3wiQY110ANx8R+5hn7JjQo9UwRajiELMMZTnjUW5oi0pDadL9SDbffxCAiDbuAhmZBJNUQj9yQhm1INZxjRQ5PaVUfadiHzdJIzSeuRKThBBbDJUNSTUQaoorFrFwsHQ4fETZRSMMzwMbiyfBmaWhCd4o0vIQZRjZQcwjJpqCz9HJ5bP3eDZppYIbLmWbGsa4i1JCrWswpFyGGmP3vnMYkPrpuPkUaHoC2h7POe5owvGbzBu1LQdvD2AeaJ/SWInT3dI7aPVUTb4OVtVobqCH9OHhB5KAmhNY3YaghKtW48UsL+opQQ9QG0Um6XLNQVE+o2NNEA7MQG+kXbK+UFbGGmL4t3rOF2FJVxBoiPswsfZqJoVr5wV9mEPUiLZM+o5huwIYjQNG3Em64RRU/qjiiv5ACco2VdcO9VPumoIg2bJN7Uyuh645xn18RflOBeu7tNzJDOCf/jhhu2CEG0Uy+ER1jkHem4m8M0a6bxM6g0rnPVzbwhvUGZZ5aK95fLHOUK4wM99o6hLJvtrPHD3G7me3Icftyor0UrTPFP1W7yJyqLDdoe5pHUu5p9tjLHB1nOPLcgj7Uyjb2MFehWGbmuGqu8hh6Qw1F28j1KjGBwcUKR67XCIfKE9Ud6grOGHxP7VXZXpT0FHtw61Brir5QvjpOTqx8r4LGeyp10VTNognUtmaSMUvGl10dN/ditC21OphK+ej2ejOqyfk6r94zc4XRN28UOplMyoOt++uPi0fAzIal0tS3sh2tlOeHJMq1wdXW7f3F8fU33leyXt92Vjr6ljWhpZi/z+jcTD0Ktx2jv+5+czpnbsJzZ991GpcrT9XWiXpnf1g1nYbr2r5vu27DMavn4ymhxBcR72A62R/3Toe9u/3J9IBs53lBEHhfEP9a4fCC5u6HV3abwXtYyy8EYbkXWs3gb/9jGLxmkt4TzfWPpJcYvjd3/PlZn58r/VoZfo9rkt3xx8M2hYd/U0deNT8jceQV/LVd2aBQ2f6aPHCQ029GizOMv7dJfnO2T5IGzhvABQGb4J8dsuBMMWExZmWYN5upgBBubOz8jo2bJ8VE2WUy/IWIYWV5JXrKfnyKXyGG/0QH/aIjyKX4lZZIkw3VpyijIoehapJ5hSPdMBiqlYkowToYKhT6BPClH29IEmRYinBDyhydExTdkDZH5xTdULdQvILOp2BDegjhQQQb0kMIDyLWEBFCdBCxhvrdTJigwIYQwQ+t4hpiJim4sYEaYiYpONdADUGC2NYNaYiapNhsijSktqSvBGL4lwwRDc0CZKpBGsIEoammmIbIVAM01DokXStDXLEQQzEUQ13D959p3r8hsB4i98DFNCxqT4PaABe3L33/ewtcuUAe1CANcckUKCjnNGqGqIUYFNbw/Z+XgqYp9jsw1hAzTYMCG2KyKVQQ/f0QEcSg0IaIIGIF4d/x6b1pUHBDcjrFfjzkMKTWRPilKPydKNrZPv7uHsPNPYogfI6yGFLmKcOdfY77pfpFMcAL8twR1lXkEOQx1KyKPA8SeAy1osj04oLJUEMx4BFkM1RW5BLkM1Rrwhnq4Ish4kXJTpKhSr7hfJ53AjH8lTx4kK+D431i+QPxsms79ZFljtXYCjj9ZjzQF2JlY8UL+wxHdr9S6TPgheWPlX8h+a36Yv3x+5Xm85T0TLaykz5Hn/GCZnxFvuFz/D8n/1R2dKk8nPzJ9Ve8IGjutuairdZuMwh4nWJ80eeN/1NBEARBEARBEARBEARBEARBEARBEARBEIrJ/2x0FvOmZ5OPAAAAAElFTkSuQmCC",
  about:"We connect talented developers with scaling teams. We are Proxify, a company founded by developers who understand that talent does not have borders.",
  about2:"We have met many companies who have tried to do the same but weren’t able to find the ‘right developer’. We have created a growing network of talented freelance developers who we ourselves would be proud to work with.",
  about3:"Headquartered in Stockholm, Uppland, Sweden, Proxify.io is a startup that provides companies with a network of talented freelance developers who work on a remote basis. Proxify employs an ambitious, like-minded team of professionals and offers its associates the chance to pursue stimulating work while shaping and defining their roles. Furthermore, team members are offered competitive hourly compensation and flexible work arrangements, such as 100% remote, work-from-anywhere jobs with full-time, flexible schedules.",
  about4:"Remote Proxify jobs posted in the past include positions in graphic design, internet & ecommerce, software development, and related fields. Believing \"talent has no borders,\" the company both works and hires remotely and looks for agile self-starters and proven team players who will thrive in an ever-changing environment. Ideal candidates are also social people who willingly communicate and suggest ideas, contribute to value-driven discussions, and drive colleagues forward. Although team members can work from any global location, \"business travels to Sweden are possible\" in some roles.",
  about5:"Proxify.io recruits developers using four methods: professional reviews, personal evaluations, technical evaluations, and references. In response to client needs, the company seeks out suitable developers, tests their code, and sets up a meet and greet between the developer and the hiring organization. If it is a good match, the developer joins the team and Proxify continues to provide regular support and quality assurance. Developers can be hired by skill, such as Laravel, PHP, WordPress, and React developers, and are screened to ensure that they can build client projects correctly from start to finish.",
  aboutPopUp:[
    {
      name:"question on management",
      details1:"Q1 Remote developers hired Through proxify are they independent or is Proxify watching over them",
      details2:"Answer 1:",
      details3:"Proxify continues to provide regular support and quality assurance",
      popUpSources:[
        {
          name:"flexjobs",
          link:"https://www.flexjobs.com/remote-jobs/company/proxifyio",
        },
      ],


    },
  ],
  aboutSource:[
    {
      name:"proxify",
      link:"https://proxify.io/company",

    },
    {
      name:"flexjobs",
      link:"https://www.flexjobs.com/remote-jobs/company/proxifyio",
    }
  ],
  MainLocation:"Headquartered in Stockholm, Uppland, Sweden  GMT(+2)",
  TotalNumberOfBranches:"!!!!!!!Unknown!!!!!!!",
  OtherLocations:[
    {
      name:"!!!!!!!Unknown!!!!!!!",
      link:"https://proxify.io/"

    },
  ],
  LocationSources:[

    {
      name:"flexjobs",
      link:"https://www.flexjobs.com/remote-jobs/company/proxifyio",
    }
  ],
  JobPost:[
  {
    name:"React/Full-stack developer",
    location:"Proxify will look for the location",
    link:"https://career.proxify.io/apply/",
    analysis:{
      status:"!!!!!!Unclear!!!!!!",
      jobLocation:"!!!!!!Unknown!!!!!",
      currentOfficeLocation:"!!!!!!Unknown!!!!!",
      details1:"After the meeting and screening then the unkown might be know",
      popUpSources:[
        {
          name:"Apply to Proxify",
          link:"https://career.proxify.io/apply/",
        },
      ],
    },
    reasonForAnalysis:"proxify works like turing after vetting you, then they look for where to settle you",
    analysisSource:[
      {name:"",
      link:""},
    ],

  }

  ],
  JobPostSources:[
    {
      name:"",
      link:""
  }
],
Employee:[
  {
  year:"Founded 2018",
  numberOfEmployee:"201 to 500 "
},
],
EmployeeType:'Full-time Employee',
EmployeeType:'Full-time Employee',
EmployeeSource:[
{
  name:"linkedin.com",
  link:"https://www.linkedin.com/company/proxify-se/people/",

},
],
Revenue:[
{
  year:'every Year',
  amount:'about $9 M'
},

],
RevenueType:'Revenue in Millions U.S dollars',
RevenueSource:[
{
  name:"zoominfo",
  link:"https://www.zoominfo.com/c/proxify-ab/547038607",

},
],
Departments:[
{
  DepartmentName:'!!!!!!Unknown!!!!!!',
  DepartmentDesc:{
    details1:"Department number:!!!!!!Unknown!!!!!!, Name:!!!!!!Unknown!!!!!!, "
  }
},
],
DepartmentSource:[
{
  name:"",
  link:"",
}
],
ApplicationStatus:"In Active",
ApplicationStage:[
  {
    stageName:"Stage1-Applying for job",
    stagePercent:100,
    about:"This is the application phase to the company for the position of full stack developer",
    about2:"!!!!!!!!!!!!!!!!!Cover letter unavialable.!!!!!!!!!!!!!!!!!",
    aboutPopUp:[
      {
        name:"Resume",
        imageName:"Resume Image",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653477784/msbGeanologyProfilePics/Resume1024_1_ws31nm.jpg",
        popUpSources:[
          {
          name:"resume ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      }
    ]
  },
  {
    stageName:"Stage2-First human response form company",
    stagePercent:100,
    about:"Monitoring first contact form the company(Not auto reply)",
    about2:"1.) first feedback was from Proxify (Talent Acquisition Specialist) her name Christina Kobets.",
    about3:"2.) she send her calender for the schedules to meet her",
    aboutPopUp:[
      {
        name:"first feedback",
        imageName:"first feedback mail for Christina Kobets",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654001252/msbGeanologyProfilePics/proxify/first_feedback_mail_dnb4be.png",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      },
      {
        name:"confirmation of setting schedules",
        imageName:"confirmation of setting schedules with Christina Kobets ",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654001252/msbGeanologyProfilePics/proxify/scheduled_with_Christina_kobets_me160b.png",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      },
      {
        name:"My reply to first feedback mail from Christina Kobets",
        imageName:"My reply to first feedback mail from Christina Kobets",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654002131/msbGeanologyProfilePics/proxify/reply_to_first_feedback_s9cbui.png",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      }
    ]
  },
  {
    stageName:"Stage3-Technical assesment",
    stagePercent:0,
    about:"Technical Assessment",

  },
  {
    stageName:"Stage4-Delevary of Assesment",
    stagePercent:0,
    about:"Delevary of Assesment",

  },
  {
    stageName:"Stage5-Awaiting a reply from assesment or follow up mail",
    stagePercent:0,
    about:"This could either be a mail with the following,",
    about2:"case 1==>This could be a mail telling you to be patient for the results of your assesment",
    about3:"case 2==> This could be a mail telling you the result of your assesment and you did not make it",
    about4:"case 3==> This could be mail on setting interview time",
    about5:"case 4==> Congratulation, you made it to interview",

  },
  {
    stageName:"Stage6-The Interview",
    stagePercent:0,
    about:"Preparation for the Interview",
    about2:"case 1==> Most common interview quesions and how to answer them",
    about3:"case 2==> reserch about those you are sopose to have interview with",
    about4:"case 3==> prepare the place and time and internet you need for the interview",
    about5:"case 4==> Have the interview",
    about6:"case 5==> Follow up interview quesions",

  },
  {
    stageName:"Stage7-Awaiting Interview Result",
    stagePercent:0,
    about:"Awaiting result of the Interview",

  },
]
},
{
  companyName:"VELTE TECHNOLOGY SOLUTIONS",
  logo:velte_logo,
  about:"",
  about2:"",
  about3:"",
  about4:"",
  about5:"",
  aboutPopUp:[
    {
      name:"",
      details1:"",
      details2:"",
      popUpSources:[
        {
          name:"",
          link:"",
        },
      ],


    },
  ],
  aboutSource:[
    {
      name:"",
      link:"",

    }
  ],
  MainLocation:"!!!unknown!!!",
  TotalNumberOfBranches:"!!!!!!!Unknown!!!!!!!",
  OtherLocations:[
    {
      name:"!!!!!!!Unknown!!!!!!!",
      link:""

    },
  ],
  LocationSources:[

    {
      name:"",
      link:"",
    }
  ],
  JobPost:[
  {
    name:"React/Full-stack developer",
    location:"!!!unknown!!!",
    link:"referrals",
    analysis:{
      status:"!!!!!!Unclear!!!!!!",
      jobLocation:"!!!!!!Unknown!!!!!",
      currentOfficeLocation:"!!!!!!Unknown!!!!!",
      details1:"",
      popUpSources:[
        {
          name:"",
          link:"",
        },
      ],
    },
    reasonForAnalysis:"",
    analysisSource:[
      {name:"",
      link:""},
    ],

  }

  ],
  JobPostSources:[
    {
      name:"",
      link:""
  }
],
Employee:[
  {
  year:"",
  numberOfEmployee:""
},
],
EmployeeType:'Part-time Employee',
EmployeeSource:[
{
  name:"",
  link:"",

},
],
Revenue:[
{
  year:'',
  amount:''
},

],
RevenueType:'Revenue in Millions U.S dollars',
RevenueSource:[
{
  name:"",
  link:"",

},
],
Departments:[
{
  DepartmentName:'!!!!!!Unknown!!!!!!',
  DepartmentDesc:{
    details1:"Department number:!!!!!!Unknown!!!!!!, Name:!!!!!!Unknown!!!!!!, "
  }
},
],
DepartmentSource:[
{
  name:"",
  link:"",
}
],
ApplicationStatus:"Employed",
ApplicationStage:[
  {
    stageName:"Stage1-Applying for job",
    stagePercent:100,
    about:"This is the application phase to the company for the position of full stack developer",
    about2:"In my case the CEO reached out to me",
    aboutPopUp:[
      {
        name:"Resume",
        imageName:"Resume Image",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653477784/msbGeanologyProfilePics/Resume1024_1_ws31nm.jpg",
        popUpSources:[
          {
          name:"resume ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      }
    ]
  },
  {
    stageName:"Stage2-First human response form company",
    stagePercent:100,
    about:"Monitoring first contact form the company(Not auto reply)",
    about2:"1.) first feedback was from VELTE TECHNOLOGY SOLUTIONS Auto reply.",
    about3:"",
    aboutPopUp:[
      {
        name:"first feedback",
        imageName:"first feedback Whatsapp",
        imageLink:"",
        popUpSources:[
          {
          name:" ",
          link:""
        }
        ]
      },

      {
        name:"first reply form recruiter PRINCE OTI ACHEAMPONG ",
        imageName:"first reply form recruiter PRINCE OTI ACHEAMPONG",
        imageLink:"",
        popUpSources:[
          {
          name:"whatsapp ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      }

    ]
  },
  {
    stageName:"Stage3-First Interview",
    stagePercent:100,
    about:"First Interview with Recruiter: PRINCE OTI ACHEAMPONG",
    about2:"1.) zoom call",
    aboutPopUp:[
      {
        name:"01 chat form recruiter PRINCE OTI ACHEAMPONG ",
        imageName:"first reply form recruiter PRINCE OTI ACHEAMPONG",
        imageLink:"",
        popUpSources:[
          {
          name:"whatsapp ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      },
      {
        name:"02 chats form recruiter PRINCE OTI ACHEAMPONG ",
        imageName:"02 chats form recruiter PRINCE OTI ACHEAMPONG",
        imageLink:"",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      }

    ]

  },
  {
    stageName:"Stage4-Technical assesment",
    stagePercent:100,
    about:"Technical Assessment",
    about2:"asked for my porfolio, and that was it",

    aboutPopUp:[
      {
        // name:"01 chat form recruiter Mme Selina Scherer-Braun ",
        // imageName:"first reply form recruiter Mme Selina Scherer-Braun",
        // imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654083298/msbGeanologyProfilePics/camsole/recruiters_reply_b0nkxv.png",
        // popUpSources:[
        //   {
        //   name:"mails ",
        //   link:"https://github.com/mrsuber/my-resume-cv"
        // }
        // ]
      },]
  },
  {
    stageName:"Stage5-Delevary of Assesment",
    stagePercent:100,
    about:"No Delevary of Assesment",
    about2:"",
    aboutPopUp:[
      {
        // name:"01 chat form recruiter Mme Selina Scherer-Braun ",
        // imageName:"first reply form recruiter Mme Selina Scherer-Braun",
        // imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654083298/msbGeanologyProfilePics/camsole/recruiters_reply_b0nkxv.png",
        // popUpSources:[
        //   {
        //   name:"mails ",
        //   link:"https://github.com/mrsuber/my-resume-cv"
        // }
        // ]
      },]

  },
  {
    stageName:"Stage6-Awaiting a reply from assesment or follow up mail",
    stagePercent:100,
    about:"This could either be a mail with the following,",
    about2:"case 1==>This could be a mail telling you to be patient for the results of your assesment",
    about3:"case 2==> This could be a mail telling you the result of your assesment and you did not make it",
    about4:"case 3==> This could be mail on setting interview time",
    about5:"case 4==> Congratulation, you made it to interview",
    aboutPopUp:[
      {
        name:"case 4 ==> congrats ",
        imageName:"interview agender with PRINCE OTI ACHEAMPONG",
        imageLink:"",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      },
    ]
  },
  {
    stageName:"Stage7-The Interview",
    stagePercent:100,
    about:"Preparation for the Interview",
    about2:"case 1==> Most common interview quesions and how to answer them",
    about3:"case 2==> reserch about those you are sopose to have interview with",
    about4:"case 3==> prepare the place and time and internet you need for the interview",
    about5:"case 4==> Have the interview",
    about6:"case 5==> Follow up interview quesions",

  },
  {
    stageName:"Stage8-Awaiting Interview Result",
    stagePercent:100,
    about:"Awaiting result of the Interview",
    about2:"Interview was a success, Awaiting contract",

  },

  {
    stageName:"Stage9-Awaiting Contract",
    stagePercent:100,
    about:"Awaiting contract to sign",
    about2:"contract was successfully given by PRINCE OTI ACHEAMPONG",

    aboutPopUp:[
      {
        name:"Congratulation 🎉🎉🥳🥳🥳 🎉🎉",
        imageName:"Contract with you and VELTE TECHNOLOGY SOLUTIONS",
        imageLink:"",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      },
    ]

  },

  {
    stageName:"Stage10-Monetoring work",
    // 1% = 7days
    stagePercent:2.55,

    about:"This is helps you monitor work starting form what you do to what you must do",
    about2:"keeps track of number of employed days and number of work days",

    aboutPopUp:[
      {
        name:"",
        imageName:"",
        imageLink:"",
        popUpSources:[
          {
          name:"",
          link:""
        }
        ]
      },
    ],
    stageAnalysis:{
      startWorkDay:"01 August 2022",

    },
    menu:[
      {
        name:'Day-01 01 August 2022 ',
        detail:"design ticket master web application using figma",
        detail1:"this website is to sell tickets for shows, online, it should have a dashboard for proper monitoring",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-01 01 August 2022 ",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },


    ],
  },
]
},
{
  companyName:"camsol",
  logo:camsol_logo1,
  about:"IT PROGRAM ==>Even during their studies, young people in the IT degree program can deepen the application of their theoretical knowledge in practical projects through the support of international mentors. In cooperation with World Charity Tour, we support with obstacles, transfer knowledge and accompany successes",
  about2:"EMPLOYMENT AFTER UNIVERSITY ==>We offer you a career start in a sustainable position for a German company directly after graduation. This way you will receive a good starting salary and can gain experience. You will be accompanied in your growth and take responsibility.",
  about3:"INTERNATIONAL PROJECTS ==>The projects with our international partners allow you to interact directly with clients and potential employers. In this way, you can overcome hurdles and concerns and thus increase your chances of being hired.",
  about4:"RECRUITMENT AND TRANSFER ==> We support you in your life's journey. With our experience, we can overcome regulatory obstacles and talk to potential employers so you can fulfill your vision.",
  about5:"",
  aboutPopUp:[
    {
      name:"",
      details1:"",
      details2:"",
      popUpSources:[
        {
          name:"",
          link:"",
        },
      ],


    },
  ],
  aboutSource:[
    {
      name:"camsole",
      link:"https://camsol.io/",

    }
  ],
  MainLocation:"!!!unknown!!!",
  TotalNumberOfBranches:"!!!!!!!Unknown!!!!!!!",
  OtherLocations:[
    {
      name:"!!!!!!!Unknown!!!!!!!",
      link:"https://camsol.io/"

    },
  ],
  LocationSources:[

    {
      name:"https://camsol.io/",
      link:"https://camsol.freshteam.com/jobs/DpLc3lhS0I8E/full-stack-developer-remote#applicant-form",
    }
  ],
  JobPost:[
  {
    name:"React/Full-stack developer",
    location:"!!!unknown!!!",
    link:"https://camsol.freshteam.com/jobs/DpLc3lhS0I8E/full-stack-developer-remote#applicant-form",
    analysis:{
      status:"!!!!!!Unclear!!!!!!",
      jobLocation:"!!!!!!Unknown!!!!!",
      currentOfficeLocation:"!!!!!!Unknown!!!!!",
      details1:"",
      popUpSources:[
        {
          name:"Apply to camsole",
          link:"https://camsol.freshteam.com/jobs/DpLc3lhS0I8E/full-stack-developer-remote#applicant-form",
        },
      ],
    },
    reasonForAnalysis:"",
    analysisSource:[
      {name:"",
      link:""},
    ],

  }

  ],
  JobPostSources:[
    {
      name:"",
      link:""
  }
],
Employee:[
  {
  year:"",
  numberOfEmployee:""
},
],
EmployeeType:'Full-time Employee',
EmployeeSource:[
{
  name:"camsole jobs",
  link:"https://camsol.freshteam.com/jobs/DpLc3lhS0I8E/full-stack-developer-remote#applicant-form",

},
],
Revenue:[
{
  year:'',
  amount:''
},

],
RevenueType:'Revenue in Millions U.S dollars',
RevenueSource:[
{
  name:"",
  link:"",

},
],
Departments:[
{
  DepartmentName:'!!!!!!Unknown!!!!!!',
  DepartmentDesc:{
    details1:"Department number:!!!!!!Unknown!!!!!!, Name:!!!!!!Unknown!!!!!!, "
  }
},
],
DepartmentSource:[
{
  name:"",
  link:"",
}
],
ApplicationStatus:"Employed",
ApplicationStage:[
  {
    stageName:"Stage1-Applying for job",
    stagePercent:100,
    about:"This is the application phase to the company for the position of full stack developer",
    about2:"!!!!!!!!!!!!!!!!!Cover letter unavialable.!!!!!!!!!!!!!!!!!",
    aboutPopUp:[
      {
        name:"Resume",
        imageName:"Resume Image",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653477784/msbGeanologyProfilePics/Resume1024_1_ws31nm.jpg",
        popUpSources:[
          {
          name:"resume ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      }
    ]
  },
  {
    stageName:"Stage2-First human response form company",
    stagePercent:100,
    about:"Monitoring first contact form the company(Not auto reply)",
    about2:"1.) first feedback was from Camsole Auto reply.",
    about3:"2.) recomended by Carine Kongnyu to send message on Whatapp.",
    aboutPopUp:[
      {
        name:"first feedback",
        imageName:"first feedback mail for Camsole",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654081810/msbGeanologyProfilePics/camsole/first_auto_reply_h22ozw.png",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      },
      {
        name:"recomended by Carine Kongnyu to send message on Whatapp",
        imageName:"recomended by Carine Kongnyu to send message on Whatapp ",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654081811/msbGeanologyProfilePics/camsole/first_Whatsapp_text_puavuz.png",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      },
      {
        name:"first reply form recruiter Mme Selina Scherer-Braun ",
        imageName:"first reply form recruiter Mme Selina Scherer-Braun",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654083298/msbGeanologyProfilePics/camsole/recruiters_reply_b0nkxv.png",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      }

    ]
  },
  {
    stageName:"Stage3-First Interview",
    stagePercent:100,
    about:"First Interview with Recruiter: Selina Scherer-Braun",
    about2:"1.) all on whats app chat",
    aboutPopUp:[
      {
        name:"01 chat form recruiter Mme Selina Scherer-Braun ",
        imageName:"first reply form recruiter Mme Selina Scherer-Braun",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654083298/msbGeanologyProfilePics/camsole/recruiters_reply_b0nkxv.png",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      },
      {
        name:"02 chats form recruiter Mme Selina Scherer-Braun ",
        imageName:"02 chats form recruiter Mme Selina Scherer-Braun",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654087970/msbGeanologyProfilePics/camsole/02_chat_y7mg1q.png",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      }
      ,
      {
        name:"03 chats form recruiter Mme Selina Scherer-Braun ",
        imageName:"03 chats form recruiter Mme Selina Scherer-Braun",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654087970/msbGeanologyProfilePics/camsole/03_chat_wea9vv.png",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      },
      {
        name:"04 chats form recruiter Mme Selina Scherer-Braun ",
        imageName:"04 chats form recruiter Mme Selina Scherer-Braun",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654087970/msbGeanologyProfilePics/camsole/chat_04_mzrgnv.png",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      },
      {
        name:"05 chats form recruiter Mme Selina Scherer-Braun ",
        imageName:"05 chats form recruiter Mme Selina Scherer-Braun",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654087970/msbGeanologyProfilePics/camsole/chat_05_osrghg.png",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      },
      {
        name:"06 chats form recruiter Mme Selina Scherer-Braun ",
        imageName:"06 chats form recruiter Mme Selina Scherer-Braun",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654087971/msbGeanologyProfilePics/camsole/chat_06_ptyj1m.png",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      },
      {
        name:"07 chats form recruiter Mme Selina Scherer-Braun ",
        imageName:"07 chats form recruiter Mme Selina Scherer-Braun",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654087971/msbGeanologyProfilePics/camsole/chat_07_skd9yj.png",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      },
      {
        name:"08 chats form recruiter Mme Selina Scherer-Braun ",
        imageName:"08 chats form recruiter Mme Selina Scherer-Braun",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654087971/msbGeanologyProfilePics/camsole/chat_08_f9kjai.png",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      }
    ]

  },
  {
    stageName:"Stage4-Technical assesment",
    stagePercent:100,
    about:"Technical Assessment",
    about2:"This was building an app and working as a team",

    aboutPopUp:[
      {
        // name:"01 chat form recruiter Mme Selina Scherer-Braun ",
        // imageName:"first reply form recruiter Mme Selina Scherer-Braun",
        // imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654083298/msbGeanologyProfilePics/camsole/recruiters_reply_b0nkxv.png",
        // popUpSources:[
        //   {
        //   name:"mails ",
        //   link:"https://github.com/mrsuber/my-resume-cv"
        // }
        // ]
      },]
  },
  {
    stageName:"Stage5-Delevary of Assesment",
    stagePercent:100,
    about:"Delevary of Assesment",
    about2:"This was a test on building andriod app working with Mr Tobias",
    aboutPopUp:[
      {
        // name:"01 chat form recruiter Mme Selina Scherer-Braun ",
        // imageName:"first reply form recruiter Mme Selina Scherer-Braun",
        // imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654083298/msbGeanologyProfilePics/camsole/recruiters_reply_b0nkxv.png",
        // popUpSources:[
        //   {
        //   name:"mails ",
        //   link:"https://github.com/mrsuber/my-resume-cv"
        // }
        // ]
      },]

  },
  {
    stageName:"Stage6-Awaiting a reply from assesment or follow up mail",
    stagePercent:100,
    about:"This could either be a mail with the following,",
    about2:"case 1==>This could be a mail telling you to be patient for the results of your assesment",
    about3:"case 2==> This could be a mail telling you the result of your assesment and you did not make it",
    about4:"case 3==> This could be mail on setting interview time",
    about5:"case 4==> Congratulation, you made it to interview",
    aboutPopUp:[
      {
        name:"case 4 ==> congrats ",
        imageName:"interview agender with Mrs Selina and Mr Tobias",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654599818/msbGeanologyProfilePics/camsole/interview_nzkiuy.png",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      },
    ]
  },
  {
    stageName:"Stage7-The Interview",
    stagePercent:100,
    about:"Preparation for the Interview",
    about2:"case 1==> Most common interview quesions and how to answer them",
    about3:"case 2==> reserch about those you are sopose to have interview with",
    about4:"case 3==> prepare the place and time and internet you need for the interview",
    about5:"case 4==> Have the interview",
    about6:"case 5==> Follow up interview quesions",

  },
  {
    stageName:"Stage8-Awaiting Interview Result",
    stagePercent:100,
    about:"Awaiting result of the Interview",
    about2:"Interview was a success, Awaiting contract",

  },

  {
    stageName:"Stage9-Awaiting Contract",
    stagePercent:100,
    about:"Awaiting contract to sign",
    about2:"contract was successfully given by Selina",

    aboutPopUp:[
      {
        name:"Congratulation 🎉🎉🥳🥳🥳 🎉🎉",
        imageName:"Contract with you and camsol",
        imageLink:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1654674016/msbGeanologyProfilePics/camsole/template2_ccttar.jpg",
        popUpSources:[
          {
          name:"mails ",
          link:"https://github.com/mrsuber/my-resume-cv"
        }
        ]
      },
    ]

  },

  {
    stageName:"Stage10-Monetoring work",
    // 1% = 7days
    stagePercent:2.55,

    about:"This is helps you monitor work starting form what you do to what you must do",
    about2:"keeps track of number of employed days and number of work days",

    aboutPopUp:[
      {
        name:"",
        imageName:"",
        imageLink:"",
        popUpSources:[
          {
          name:"",
          link:""
        }
        ]
      },
    ],
    stageAnalysis:{
      startWorkDay:"13 June 2022",

    },
    menu:[
      {
        name:'Day-01 13 June 2022 ',
        detail:"day worm welcomes on whatsapp",
        detail1:"create an account for task management in https://www.notion.so/camsol/c5037995bb3649c1b86d87c198df142f?v=a4307ef7d1ba4061ac0b5581bb91416b",
        detail2:"8:00am meeting, We have progress reviews at 12pm and 3pm",
        detail3:"my loging to the wine testing directus data base",
        detail4:"username: my email",
        detail5:"passwid: Online2022#@!",
        detail6:"link : https://twuw1gfg.directus.app",
        detail7:"sending post request and getting response",
        detail8:"work complete at 5pm",
        ancorName:"Day-01 13 June 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-02 14 June 2022 ',
        detail:"started working on the the app tap bar",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-02 14 June 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-03 15 June 2022 ',
        detail:"worked on the display home screen and the detail screen",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-03 15 June 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-04 16 June 2022 ',
        detail:"completed the design of the home screen",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-04 16 June 2022",
        popup1Name:"Home Screen",
        popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1656005435/msbGeanologyProfilePics/camsole/homeScreen_bs9vmm.png",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-05 17 June 2022 ',
        detail:"finalised other pages lay graound of the app, ",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-05 17 June 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-06 18 June 2022 ',
        detail:"week end",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-06 18 June 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-07 19 June 2022 ',
        detail:"week end",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-07 19 June 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-08 20 June 2022 ',
        detail:"had a meeting with Mmm Larissa, about the vision of the app and work the first flow",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-08 20 June 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },

      {
        name:'Day-09 21 June 2022 ',
        detail:"working on the first flow of the app",
        detail1:" completed the detial screen",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-09 21 June 2022",
        popup1Name:"Detail Screen",
        popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1656005436/msbGeanologyProfilePics/camsole/detialScreen_h6ymq4.png",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-10 22 June 2022 ',
        detail:"working on the first flow of the app",
        detail1:" working on the detail description screen",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-10 22 June 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-11 23 June 2022 ',
        detail:"working on the first flow of the app",
        detail1:" finished the first flow of the app and awaiting feedback form client (Larissa)",
        detail2:" started the home screen of the quesion page.",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-11 23 June 2022",
        popup1Name:"Detail Description Screen",
        popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1656005436/msbGeanologyProfilePics/camsole/detailDescriptionScreen_px9hnb.png",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-12 24 June 2022 ',
        detail:"working on the first flow of the app",
        detail1:"started with the flow of the quesion section",
        detail2:" screens can navigate to each section fo the module",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-12 24 June 2022",
        popup1Name:"Detail Description Screen",
        popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1656005436/msbGeanologyProfilePics/camsole/detailDescriptionScreen_px9hnb.png",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-13 25 June 2022 ',
        detail:"week end",
        detail1:"",
        detail2:" ",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-13 25 June 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-14 26 June 2022 ',
        detail:"week end",
        detail1:"",
        detail2:" ",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-14 26 June 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-15 27 June 2022 ',
        detail:"worked on the quesion and answer model of wine testing",
        detail1:"the landing page",
        detail2:" ",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-15 27 June 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },{
        name:'Day-16 28 June 2022 ',
        detail:"completed the quesion and answer model flow",
        detail1:"anwer quesion using demo data",
        detail2:" started work on how to connect to data base",
        detail3:"over worked so at the end of the day, installed promodoro timer to manage time while working",
        detail4:"had a long meeting with Mr Tobias to do the following. **his words**",
        detail5:"* I think your work is very good and I am very happy that you are working with Camsol",
        detail6:"* Regarding MVP, you should document your understanding in Notion and send it to Larissa for approval.",
        detail7:"* You should check if you focus enough on learning at work after 70/20/10",
        detail8:"* Figma is a worthwhile technology to learn - feel free to write with Steve about best pratice and resources",
        detail9:"* Please look at Romis so that we learn as a team and you have a second project to assist with",
        ancorName:"Day-16 28 June 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },{
        name:'Day-17 29 June 2022 ',
        detail:"start work at 8:00 am with morning meeting",
        detail1:"casole migrated today to slack,",
        detail2:" it looks like my first salary would be paid today",
        detail3:"==>1 connecting database to app start at 9:20am",
        detail4:"==> completed to created demo quesion data from database to connect to app(10:00am)",
        detail5:"==> starting to implement data in the app",
        detail6:"==> completely implemented data in the app",
        detail7:"",
        detail8:"",
        ancorName:"Day-16 29 June 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-18 30 June 2022 ',
        detail:"reading and creating a demo app on figma",
        detail1:"created the first screens on figma",
        detail2:" currently working on the MVP of winetasting",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-18 30 June 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-19 1 july 2022 ',
        detail:"continues on the MVP of the winetasting",
        detail1:"install and go through romis project",
        detail2:" i also created more screen for wine tasting ",
        detail3:" i help Djomo walk through camsole",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        ancorName:"Day-19 1 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-20 2 july 2022 ',
        detail:"week end",
        detail1:"planning of going shoping to buy work things",
        detail2:" 1.battery for my laptop",
        detail3:" 2.modem for internet",
        detail4:" 3.camtel simcard",
        detail5:"4. internet for camtel",
        detail6:"5.ear phones",
        detail7:"6, bag",
        detail8:"7, memory card",
        detail9:"",
        ancorName:"Day-20 2 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-21 3 july 2022 ',
        detail:"week end",
        detail1:"make sure you install romis project and it works",
        detail2:" ",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-21 3 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-22 4 july 2022 ',
        detail:"discause with jum about the build process of wine tasting on github",
        detail1:"there was no current so i mostly worked at night",
        detail2:" completed the screens for wine tasting",
        detail3:"install a emulator and tried out the most resent romis porject",
        detail4:"clone a new porject of wine tasting and istalled to see the error Djomo was facing",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-22 4 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },

      {
        name:'Day-23 5 july 2022 ',
        detail:"connecting the screens together for Larissa review",
        detail1:"talk with Djomo about wine tasting",
        detail2:"talk with carine about the database of wine tasting ",
        detail3:" talk with larissa about the MVP of wine tasting",
        detail4:"fix the build failling process of wine tasting on github",
        detail5:"clean the code of wine tasting and refator to the essencial",
        detail6:"creating the task to do on Notion",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-23 5 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-24 6 july 2022 ',
        detail:"Initiated conversion with Larissa",
        detail1:"build two screens of wine tasting",
        detail2:"refactor code of wine tasting ",
        detail3:" started documenting winetasting MVP",
        detail4:"got additional money from CEO 45458 frs",
        detail5:"clean the code of wine tasting and refator to the essencial",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-24 6 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-25 7 july 2022 ',
        detail:"discaused more with Larissag about the MVP",
        detail1:"build a screen on figma for Romis project",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-25 7 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-26 8 july 2022 ',
        detail:"work on romis details page,",
        detail1:"strip down all of larissa project to todo list on github",
        detail2:"work on the welcome guide screen",
        detail3:"->Step 1, make changes on romis design ----complete---",
        detail4:"->step 2 designing the porduct screen for romis",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-26 8 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-27 09 july 2022 ',
        detail:"weekend,",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-27 09 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-28 10 july 2022 ',
        detail:"weekend,",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-28 10 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-28 11 july 2022 ',
        detail:"complete the Romis design,",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-28 11 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-29 12 july 2022 ',
        detail:"had a meeting with larissa about the mvp",
        detail1:"almost completed the desing for Romis",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-29 12 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-30 13 july 2022 ',
        detail:"complete Romis design",
        detail1:"complete winetasting design",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-30 13 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-31 14 july 2022 ',
        detail:"talked about updates on romis",
        detail1:"traveled to douala to see carine and visit Azimi",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-31 14 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },

      {
        name:'Day-32 15 july 2022 ',
        detail:"too the day off",
        detail1:"visit Azimi and family and propose to her",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-32 15 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-33 16 july 2022 ',
        detail:"weekend",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-33 16 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-34 17 july 2022 ',
        detail:"weekend",
        detail1:"r",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-34 17 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-35 18 july 2022 ',
        detail:"complete wine tasting screens and implement the updates",
        detail1:"complete romis and implement the updates",
        detail2:"talk to madame lassa about the logic she was sopose to give",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-35 18 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-36 19 july 2022 ',
        detail:"completed the porsion i could do alone about wine tasting waiting for larisa to make up her",
        detail1:"completed first part of romis",
        detail2:"have a problem of haw to go about reading the translated quran",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-36 19 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-37 20 july 2022 ',
        detail:"update on wine tasting design",
        detail1:"update on Romis design",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-37 20 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-38 21 july 2022 ',
        detail:"update on wine tasting design the reset password screen",
        detail1:"had a talk with larissa about the recipe, currently designed the video",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-38 21 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-39 22 july 2022 ',
        detail:"worked on the wine expert flow of winetasting,",
        detail1:"worked on the wine pairing flow screen of winetasting",
        detail2:"worked on the details page of the Romis",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-39 22 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },{
        name:'Day-40 23 july 2022 ',
        detail:"WEEK END, had to call the numbers in my phone as programed, arange a meeting with AdulMalik sunday",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-40 23 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-41 24 july 2022 ',
        detail:"WEEK END, had a meeting with AdulMalik and discause the meeting thing",
        detail1:"arange another meeting with shirk Yakub sunday 31 july 2022",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-41 24 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },{
        name:'Day-41 25 july 2022 ',
        detail:"finished the recipe flow of winetasting, worked on the chekout screen of Romis",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-41 25 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-42 26 july 2022 ',
        detail:"create the whole issue of authenticatin and autorisation of wine tasting on github",
        detail1:"update romis and got feeback form client",
        detail2:"was assign another project about romis",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-42 26 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-43 27 july 2022 ',
        detail:"morning mettings at 8 am",
        detail1:"send my invoice of 220,000",
        detail2:"had a short chat with Romis, work on some updates",
        detail3:"working on github about wine tasting issues",
        detail4:"discaused with madam selina about being a team leader",
        detail5:"set up all git hub issues",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-43 27 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-44 28 july 2022 ',
        detail:"morning mettings at 8 am",
        detail1:"successfully made a teamleader",
        detail2:"members of my team Djomo, issable and 3 more fullstact dev to follow",
        detail3:"cleared the first issue about wine tasting on Romis",
        detail4:"worked with romis design and updates",
        detail5:"started chat on invoice of romis supply",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-44 28 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-45 29 july 2022 ',
        detail:"morning mettings at 8 am",
        detail1:"talked with alden and issabel, member of my team",
        detail2:"worked on the romis system design for warehouse",
        detail3:"Updates on the Romis fation app",
        detail4:"small update on the wine tasting ",
        detail5:"got paid today 200000",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-45 29 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-46 30 july 2022 ',
        detail:"weekend, ",
        detail1:"started the new company project()",
        detail2:"completed animation of the Romis wearhouse management",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-46 30 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-47 31 july 2022 ',
        detail:"weekend, ",
        detail1:"started the new company project()",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-47 31 july 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-48 01 August 2022 ',
        detail:"started today as a team leader ",
        detail1:"1 implementing wine tasting , all issue are already set and @Alden Brown  and I are active programmers in this",
        detail2:"2 set up Romis and get familiar with @Cesar Ndjoko and see if he can start implementing this,",
        detail3:"demo the flow of Romis (frank) to see if that is what he wanted then set it up with @Issabel, she likes and is good in design she could work on the two projects simultanousely,(this is because she told me she is almost rounding up with Acteevent design)",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"apply for internet",
        ancorName:"Day-48 01 August 2022",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-724 06 June 2024 ',
        detail:"Town hall meeting cordiantion and attendance ",
        detail1:"pay samuel for te sick leave 16000",
        detail2:"cordinate with Nkamibo to work on slides to start",
        detail3:"following up on the 3.520,00 EUR sent to cameroon but accounts never creadited, wrote a mail again and sent to Mr Ebeneza Bank Manager",
        detail4:"work on the office walls Camsol Technologies",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-724 06 June 2024",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-725 07 June 2024',
        detail:"Town hall meeting slides working on them",
        detail1:"had a meeting with leo at 8am to show charity mvp 1",
        detail2:"recived the figma start template from Brown",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-725 07 June 2024",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-726 08 June 2024',
        detail:"weekend, prepare town hall slides",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-726 08 June 2024",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },

      {
        name:'Day-727 09 June 2024',
        detail:"weekend, prepare town hall slides",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-727 09 June 2024",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      {
        name:'Day-728 10 June 2024',
        detail:"Town Hall meeting presentation, Discord did not work",
        detail1:"payed tax to Nokeli",
        detail2:"follow up about Carine to Max",
        detail3:"payed for myles medical bill",
        detail4:"",
        detail5:"",
        detail6:"",
        detail7:"",
        detail8:"",
        detail9:"",
        ancorName:"Day-728 10 June 2024",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
    ],
  },
]
},



]
